
angular.module('manager.users', []);
